import { render, staticRenderFns } from "./main.vue?vue&type=template&id=13ae8f5e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=13ae8f5e&lang=scss"
import style1 from "./main.vue?vue&type=style&index=1&id=13ae8f5e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae8f5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ae8f5e')) {
      api.createRecord('13ae8f5e', component.options)
    } else {
      api.reload('13ae8f5e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=13ae8f5e&scoped=true", function () {
      api.rerender('13ae8f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/documents/popup/faq/main.vue"
export default component.exports